import { useEffect, useState } from "react";
import { PreserveSearchNavigate } from "../../components/Navigate/PreserveSearchNavigate.tsx";
import { Spinner } from "../../components/Spinner/Spinner.tsx";
import { BOARDS, WORKSPACES } from "../../routes.ts";
import { boardStatePresetStore } from "../boardState/boardStatePresetStore.ts";
import { useBoards } from "../Home/HomeIndex/hooks/useBoards.ts";
import { useCreateBoard } from "../Home/HomeIndex/hooks/useCreateBoard.ts";
import { useUser } from "../hooks/useUser.ts";
import { useWorkspaceUuid } from "../hooks/useWorkspaceUuid.ts";
import { useLastSelectedWorkspaceUuid } from "../Workspace/hooks/useLastSelectedWorkspaceUuid.ts";

export const BoardRedirect = () => {
  const { user } = useUser();
  const lastSelectedWorkspaceUuid = useLastSelectedWorkspaceUuid();
  if (!user) return <Spinner />;

  return (
    <PreserveSearchNavigate
      to={`${WORKSPACES}/${
        lastSelectedWorkspaceUuid ?? user.workspaces[0].uuid
      }/${BOARDS}`}
    />
  );
};

export const GetExistingOrCreateBoardRedirect = () => {
  const workspaceUuid = useWorkspaceUuid();
  const { userBoards, isLoading } = useBoards();
  const { createBoard, isCreateBoardLoading } = useCreateBoard({
    onSuccess: (uuid) => {
      setBoardUuid(uuid);
    },
  });
  const [boardUuid, setBoardUuid] = useState<string | null>(null);

  useEffect(() => {
    if (boardUuid) return;
    if (userBoards?.length) {
      setBoardUuid(userBoards.sortDesc((it) => it.edited_at)[0].uuid);
    }
    if (!isCreateBoardLoading && !isLoading && !userBoards?.length) {
      createBoard();
    }
  }, [boardUuid, createBoard, userBoards, isCreateBoardLoading, isLoading]);

  if (!boardUuid) return <Spinner />;

  // XXX: Extra user based customization based on extra url params or user preferences
  boardStatePresetStore.setBoardStatePreset({
    boardUuid,
    boardStatePreset: boardStatePresetStore.getState().boardStatePreset,
    baseBoardState: {},
  });

  return (
    <PreserveSearchNavigate
      to={`${WORKSPACES}/${workspaceUuid}/${BOARDS}/${boardUuid}`}
    />
  );
};
